import React from 'react';
import { Route, Routes } from 'react-router-dom';
import '../../assets/css/animate.css';
import MasterContainer from 'containers/MasterContainer/MasterContainer';
import { useNavigate, useLocation } from 'react-router-dom';

const IndexWrapper = (props) => {
    const history = useNavigate()
    const location = useLocation()
    return (<>
        <Routes>
            <Route path='/*' element={<MasterContainer history={{ history, location: location }} />} />
        </Routes>
    </>)
}
export default IndexWrapper;
